import { Box, Tabs, Tab } from '@mui/material'

function ReportTabs({ value, onChange }) {
  return (
    <Box sx={{ px: 2, pb: 0 }}>
      <Tabs value={value} onChange={(_, v) => onChange(v)}>
        <Tab label="Invoice-wise" />
        <Tab label="Product-wise" />
      </Tabs>
    </Box>
  )
}

export default ReportTabs
